import Vue from 'vue'

export default ({ $integrationsManager, $uiEvents, nuxtState }, inject) => {
    const device = Vue.observable(nuxtState.deviceContext)

    // Get device constant before before the client starts manipulating the device object
    const deviceFromServer = getDevice()

    // Inject device state to the app
    inject('device', device)

    const isMobileQuery = window.matchMedia(`screen and (max-width: 767px)`)
    const isSmallQuery = window.matchMedia(`screen and (max-width: 1023px)`)
    const isDesktopQuery = window.matchMedia(`screen and (min-width: 1024px)`)

    // Add listeners for real-time eval
    // After speaking with Josh, the previous code was using a deprecated function called AddListener
    // Safari < 14 doesn't support the addEventListener call and we determined that it was such a small subset of people,
    // we will just use the new way and just not do resizing for old safari people.
    if (isMobileQuery.addEventListener) isMobileQuery.addEventListener('change', isMobileCheck)
    if (isSmallQuery.addEventListener) isSmallQuery.addEventListener('change', isSmallCheck)
    if (isDesktopQuery.addEventListener) isDesktopQuery.addEventListener('change', isDesktopCheck)

    $integrationsManager.loaders.onNuxtReadyLoader(() => {
        isMobileCheck(isMobileQuery)
        isSmallCheck(isSmallQuery)
        isDesktopCheck(isDesktopQuery)

        const clientDevice = getDevice()
        if (deviceFromServer !== clientDevice) {
            setTimeout(() => {
                $uiEvents.$emit('deviceChanged', {
                    from: deviceFromServer,
                    to: clientDevice,
                })
            }, 2000)
        }
    }, 1)

    // Matches on Mobile
    function isMobileCheck(e) {
        device.isMobile = e.matches
        device.key = e.matches ? 'mobile' : 'desktop'
    }

    // Matches on Tablet or Smaller
    function isSmallCheck(e) {
        device.isSmall = e.matches
    }

    // Matches on Desktop
    function isDesktopCheck(e) {
        device.isDesktop = e.matches
    }

    function getDevice() {
        if (device.isDesktop) return 'desktop'
        if (device.isSmall && !device.isMobile) return 'tablet'

        return 'mobile'
    }
}
